module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tenders/tenders-edit/tenders-edit.component.css
// module id = ./src/app/components/tenders/tenders-edit/tenders-edit.component.css
// module chunks = main